import { SERVER_URL } from './../config/contants';
import { HEADERS } from './../config/contants';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class Cadastro {

  contentHeader: Headers = new Headers(HEADERS);

  constructor(public http: Http) {

  }

  cadastrarUsuario(cadastroForm) {

    let body = {
      cpf: cadastroForm.value.cpf.replace(/\D/g,''),
      nome: cadastroForm.value.nome,
      email: cadastroForm.value.email,
      nascimento: cadastroForm.value.nascimento,
      celular: cadastroForm.value.celular,
      genero: cadastroForm.value.genero,
      senha: cadastroForm.value.password
    }

    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'autenticacao/cadastrar', JSON.stringify(body), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          resolve(data['response'])
        },
        err => {
          reject(err)
        }
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/cadastro.ts